<dx-tab-panel
    class="np-template-product-vertical-tabs h-100"
    [selectedIndex]="0"
    [tabsPosition]="'left'"
    [showNavButtons]="true"
    [scrollByContent]="true"
    [loop]="true"
>
  <dxi-item title="{{ 'Produkt' | translate }}" [badge]="tabBadge(productTabs.produkt)">
    <div *dxTemplate>
      <infos/>
    </div>
  </dxi-item>

  <dxi-item title="{{ 'Texte' | translate }}" [badge]="tabBadge(productTabs.texts)">
    <div *dxTemplate>
      <np-product-texts
          [(model)]="model"
          [(showToolTips)]="showToolTips"
          [(selectedElements)]="selectedElements"
          [templateView]="true"
          [showLinkButtons]="false"
          [isPrint]="modelService?.catalogService?.catalog?.usePrintView"
          [(selectedTranslateLanguage)]="modelService.loginService.selectedTranslateLanguage"
          [(productTranslation)]="modelService.translationService.productTranslation"
          (onValueChanged)="update($event)"
          (elementSelected)="elementSelectFunction($event)"
          [showDragHandle]="showDragHandle"
          [dragFilter]="'> *'"
          (excelElementDropped)="excelElementDrop($event)">
      </np-product-texts>
    </div>
  </dxi-item>

  <dxi-item title="{{ 'Medien' | translate }}" [badge]="tabBadge(productTabs.medien)" [disabled]="massDataChangeMode">
    <div *dxTemplate>
      <mimes
          [(model)]="model.mimes"
          [(product)]="model"
          [(showToolTips)]="showToolTips"
          [(selectedElements)]="selectedElements"
          [templateView]="true"
          [(exportMode)]="exportMode"
          (onValueChanged)="update($event)"
          (elementSelected)="elementSelectFunction($event)"
          [showDragHandle]="showDragHandle"
          [dragFilter]="'> *'"
          (excelElementDropped)="excelElementDrop($event)"
          (elementDeleted)="elementDelete($event)"
      ></mimes>
    </div>
  </dxi-item>


  <dxi-item title="{{ 'Features' | translate }}" [badge]="tabBadge(productTabs.features)">
    <div *dxTemplate>
      <featuresystems
          [featureSystems]="model.featureSystems"
          [templateView]="true"
          [displayMode]="exportMode ? 'export' : 'import'"
          (addEcommerceFeatures)="addEcommerceFeatures()"
          (onValueChanged)="update($event)"
      ></featuresystems>
    </div>
  </dxi-item>

  <dxi-item title="{{ 'Bestelldetails' | translate }}" [badge]="tabBadge(productTabs.bestelldetails)">
    <div *dxTemplate>
      <orderDetail
          [(model)]="model"
          [(showToolTips)]="showToolTips"
          [(selectedElements)]="selectedElements"
          [templateView]="true"
          (onValueChanged)="update($event)"
          [(hasAddonNordwest)]="loginService.hasAddonNordwest"
          [(hasAddonLEGALITY)]="loginService.hasAddonLEGALITY"
          (elementSelected)="elementSelectFunction($event)"
          [showDragHandle]="showDragHandle"
          [dragFilter]="'> *'"
          (excelElementDropped)="excelElementDrop($event)"
      ></orderDetail>
    </div>
  </dxi-item>

  <dxi-item title="{{ 'Preislisten' | translate }}" [badge]="tabBadge(productTabs.preislisten)">
    <div *dxTemplate>
      <prices
          [(model)]="model"
          [(showToolTips)]="showToolTips"
          [(selectedElements)]="selectedElements"
          [templateView]="true"
          (onValueChanged)="update($event)"
          [(hasAddonNordwest)]="loginService.hasAddonNordwest"
          [(hasAddonLEGALITY)]="loginService.hasAddonLEGALITY"
          [(priceLists)]="catalogService.catalog.priceLists"
          (elementSelected)="elementSelectFunction($event)"
          [showDragHandle]="showDragHandle"
          [dragFilter]="'> *'"
          (excelElementDropped)="excelElementDrop($event)"
          (elementDeleted)="elementDelete($event)"
      ></prices>
    </div>
  </dxi-item>

  <dxi-item title="{{ 'Logistik' | translate }}" [badge]="tabBadge(productTabs.logistik)">
    <div *dxTemplate>
      <logistic
          [(model)]="model"
          [(showToolTips)]="showToolTips"
          [(selectedElements)]="selectedElements"
          [templateView]="true"
          (onValueChanged)="update($event)"
          (elementSelected)="elementSelectFunction($event)"
          [showDragHandle]="showDragHandle"
          [dragFilter]="'> *'"
          (excelElementDropped)="excelElementDrop($event)"
      ></logistic>
    </div>
  </dxi-item>

  <dxi-item title="{{ 'Referenzen' | translate }}" [badge]="tabBadge(productTabs.referenzen)">
    <div *dxTemplate>
      <np-product-references
          [(model)]="model"
          [(showToolTips)]="showToolTips"
          [(lastImageUpload)]="catalogService.catalog.lastImageUpload"
          [(selectedElements)]="selectedElements"
          [templateView]="true"
          (onValueChanged)="update($event)"
          (elementSelected)="elementSelectFunction($event)"
          [showDragHandle]="showDragHandle"
          [dragFilter]="'> *'"
          (excelElementDropped)="excelElementDrop($event)"
          (elementDeleted)="elementDelete($event)"
      ></np-product-references>
    </div>
  </dxi-item>

  <dxi-item title="{{ 'Udx' | translate }}" [badge]="tabBadge(productTabs.udx)" *ngIf="loginService.hasAddonUDX">
    <div *dxTemplate>
      <udx
          [(model)]="model.udxs"
          [(product)]="model"
          [(showToolTips)]="showToolTips"
          [(selectedElements)]="selectedElements"
          [templateView]="true"
          (onValueChanged)="update($event)"
          (elementSelected)="elementSelectFunction($event)"
          [showDragHandle]="showDragHandle"
          [dragFilter]="'> *'"
          (excelElementDropped)="excelElementDrop($event)"
          (elementDeleted)="elementDelete($event)"
      ></udx>
    </div>
  </dxi-item>

  <dxi-item title="{{ 'Kategorien' | translate }}" [badge]="tabBadge(productTabs.kategorien)">
    <div *dxTemplate>
      <app-template-product-categories
          [(model)]="model"
          [(product)]="model"
          [(showToolTips)]="showToolTips"
          [(selectedElements)]="selectedElements"
          [templateView]="true"
          [(exportMode)]="exportMode"
          (onValueChanged)="update($event)"
          (elementSelected)="elementSelectFunction($event)"
          [showDragHandle]="showDragHandle"
          [dragFilter]="'> *'"
          (excelElementDropped)="excelElementDrop($event)"
          (elementDeleted)="elementDelete($event)"
      ></app-template-product-categories>
    </div>
  </dxi-item>

  <dxi-item title="{{ 'ElectronicSales' | translate }}" [badge]="tabBadge(productTabs.electronicSales)" *ngIf="loginService.hasAddonElectronicSales">
    <div *dxTemplate>
      <electronicSales
          [(model)]="model"
          [(showToolTips)]="showToolTips"
          [(selectedElements)]="selectedElements"
          [templateView]="true"
          (onValueChanged)="update($event)"
          (elementSelected)="elementSelectFunction($event)"
          [showDragHandle]="showDragHandle"
          [dragFilter]="'> *'"
          (excelElementDropped)="excelElementDrop($event)"
      ></electronicSales>
    </div>
  </dxi-item>
    <dxi-item title="{{ 'Displays' | translate }}" [badge]="tabBadge(productTabs.displays)" *ngIf="loginService.hasAddonBauvista">
    <div *dxTemplate="let company of 'displayTemplate'">
        <np-product-display
            [(model)]="model"
            [templateView]="true"
            [(selectedElements)]="selectedElements"
            [showDragHandle]="showDragHandle"
            [dragFilter]="'> *'"
            (onValueChanged)="update($event)"
            (elementSelected)="elementSelectFunction($event)"
            (excelElementDropped)="excelElementDrop($event)"
        ></np-product-display>
    </div>
    </dxi-item>
  <dxi-item title="{{ 'DPB' | translate }}" [badge]="tabBadge(productTabs.dpb)" *ngIf="loginService.hasAddonDpbImport || loginService.hasAddonDpbExport">
    <div *dxTemplate>
      <np-product-dpb
          [model]="model"
          (onValueChanged)="update($event)"
      ></np-product-dpb>
    </div>
  </dxi-item>
  <dxi-item title="{{ 'Wawi' | translate }}" [badge]="tabBadge(productTabs.wawi)" *ngIf="loginService.hasAddonWawiErp">
    <div *dxTemplate>
      <wawi
          [(model)]="model"
          [(selectedElements)]="selectedElements"
          [templateView]="true"
          (onValueChanged)="update($event)"
          (elementSelected)="elementSelectFunction($event)"
          [showDragHandle]="showDragHandle"
          [dragFilter]="'> *'"
          (excelElementDropped)="excelElementDrop($event)"
      ></wawi>
    </div>
  </dxi-item>

  <dxi-item *ngFor="let tab of customTabPages" title="{{ tab.name }}" [badge]="tabBadge(customTab(tab.id))">
    <div *dxTemplate>
      <wawi
          [(model)]="model"
          [(selectedElements)]="selectedElements"
          [templateView]="true"
          [selectedTabToShow]="'tab:' + tab.id"
          (onValueChanged)="update($event)"
          (elementSelected)="elementSelectFunction($event)"
          [showDragHandle]="showDragHandle"
          [dragFilter]="'> *'"
          (excelElementDropped)="excelElementDrop($event)"
      ></wawi>
    </div>
  </dxi-item>

  <dxi-item title="{{ 'Recht' | translate }}" [badge]="tabBadge(productTabs.recht)">
    <div *dxTemplate>
      <productLegal
          [(model)]="model"
          [(showToolTips)]="showToolTips"
          [(warrantyClasses)]="warrantyClassService.warrantyClasses"
          [(hazmatClasses)]="hazmatClassService.hazmatClasses"
          [(selectedElements)]="selectedElements"
          [templateView]="true"
          [massDataChangeMode]="massDataChangeMode"
          [showHTMLSwitch]="false"
          (onValueChanged)="update($event)"
          [(validationService)]="validationService"
          (elementSelected)="elementSelectFunction($event)"
          [showDragHandle]="showDragHandle"
          [dragFilter]="'> *'"
          (excelElementDropped)="excelElementDrop($event)"
      ></productLegal>
    </div>
  </dxi-item>

  <dxi-item title="{{ 'Lieferanten' | translate }}" [badge]="tabBadge(productTabs.lieferanten)" *ngIf="loginService.hasAddonSUPPLIERS">
    <div *dxTemplate>
      <productSuppliers
          [(product)]="model"
          [(showToolTips)]="showToolTips"
          [(selectedElements)]="selectedElements"
          [templateView]="true"
          [(exportMode)]="exportMode"
          (onValueChanged)="update($event)"
          (elementSelected)="elementSelectFunction($event)"
          [showDragHandle]="showDragHandle"
          [dragFilter]="'> *'"
          (excelElementDropped)="excelElementDrop($event)"
          (elementDeleted)="elementDelete($event)"
      ></productSuppliers>
    </div>
  </dxi-item>

  <dxi-item title="{{ 'Shopware6' | translate }}" [badge]="tabBadge(productTabs.shopware6)">
    <div *dxTemplate>
      <np-product-shopware6
          [(model)]="model"
          [(showToolTips)]="showToolTips"
          [(selectedElements)]="selectedElements"
          [templateView]="true"
          [(showProToolTips)]="showProToolTips"
          [(showPlaceHolders)]="showPlaceHolders"
          [showLinkButtons]="true"
          (onValueChanged)="update($event)"
          (elementSelected)="elementSelectFunction($event)"
          [showDragHandle]="showDragHandle"
          [dragFilter]="'> *'"
          (excelElementDropped)="excelElementDrop($event)"
      />
    </div>
  </dxi-item>

  <dxi-item title="{{ 'SCIREUM Sellsite' | translate }}" [badge]="tabBadge(productTabs.scireum)" *ngIf="loginService.hasAddonScireumSellsite">
    <div *dxTemplate>
      <np-product-scireum
          [(model)]="model"
          [(showToolTips)]="showToolTips"
          [(selectedElements)]="selectedElements"
          [(showProToolTips)]="showProToolTips"
          [templateView]="true"
          [(exportMode)]="exportMode"
          (onValueChanged)="update($event)"
          (elementSelected)="elementSelectFunction($event)"
          [showDragHandle]="showDragHandle"
          [dragFilter]="'> *'"
          (excelElementDropped)="excelElementDrop($event)"
          [excelModel]="excelModel"
      />
    </div>
  </dxi-item>

  <dxi-item title="{{ 'Einstellungen' | translate }}" [badge]="tabBadge(productTabs.einstellungen)" *ngIf="!massDataChangeMode">
    <div *dxTemplate>
      <misc
          [(model)]="model"
          [(showToolTips)]="showToolTips"
          [(selectedElements)]="selectedElements"
          [(exportMode)]="exportMode"
          (onValueChanged)="update($event)"
          (elementSelected)="elementSelectFunction($event)"
          [showDragHandle]="showDragHandle"
          [dragFilter]="'> *'"
          (excelElementDropped)="excelElementDrop($event)"
          [excelModel]="excelModel"
      ></misc>
    </div>
  </dxi-item>

  <dxi-item title="{{ 'Abverkaufszahlen' | translate }}" [badge]="tabBadge(productTabs.abverkaufszahlen)" *ngIf="!massDataChangeMode && loginService.hasAddonBauvista">
    <div *dxTemplate>
      <np-product-sellthroughfigures
          [model]="model"
          [templateView]="true"
          [(selectedElements)]="selectedElements"
          [showDragHandle]="showDragHandle"
          [dragFilter]="'> *'"
          (elementSelected)="elementSelectFunction($event)"
          (excelElementDropped)="excelElementDrop($event)"
      />
    </div>
  </dxi-item>
</dx-tab-panel>
